"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _vue = _interopRequireDefault(require("vue"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AppMain',
  data: function data() {
    return {
      cacheView: false,
      refresh: true
    };
  },
  computed: {
    cachedView: function cachedView() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.name;
    }
  },
  created: function created() {},
  watch: {
    cachedView: function cachedView(val) {
      if (!(this.$children[0] && this.$children[0].$vnode.parent)) return;
      var _this$$children$0$$vn = this.$children[0].$vnode.parent.componentInstance,
        keys = _this$$children$0$$vn.keys,
        cache = _this$$children$0$$vn.cache;
      var delCache = keys.filter(function (v) {
        return !val.includes(v);
      });
      delCache.forEach(function (v) {
        keys.splice(keys.indexOf(v), 1);
      });
      delCache.forEach(function (v, i) {
        cache[delCache[i]].componentInstance.$destroy();
        delete cache[delCache[i]];
      });
    },
    $route: {
      handler: function handler(val, old) {
        var _this = this;
        var flag = val.path.includes('/redirect') || old.path.includes('/redirect');
        if (this.$route.meta.keepAlive && flag) {
          this.refresh = false;
          this.$nextTick(function () {
            _this.refresh = true;
          });
        }
      }
    }
  },
  methods: {}
};